import { MeterRegister } from '@enmon/commons';
import { createFullOBIS } from '@enmon/commons/lib/enmon';
import { TRANSLATED_OBIS } from 'consts/registers/obises';
import { IntlShape } from 'react-intl';

export const getObisTranslation = (intl: IntlShape, meterRegister: Pick<MeterRegister, 'medium' | 'obis'>): string => {
  const { medium, obis } = meterRegister;

  const obisDescriptor = TRANSLATED_OBIS[medium]?.[obis];
  return obisDescriptor ? intl.formatMessage(obisDescriptor) : createFullOBIS(meterRegister);
};
